//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { LogicalExpressionModel } from './LogicalExpressionModel';
  import { DynamicEntityModel } from './DynamicEntityModel';
  import { RuleExpressionModel } from './RuleExpressionModel';
  
  export class DynamicRuleModel extends ModelBase {
      static readonly $typeName = 'DynamicRuleModel';
      public conditions: LogicalExpressionModel[];
      public isActive: boolean;
      public dataSetStatus: string;
      public entity: DynamicEntityModel;
      public expression: RuleExpressionModel;
      public isEnabled: boolean;
      public key: string;
      public name: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/models/DynamicRuleModel.ts